import type { SVGProps } from 'react';
const SvgLogout = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="-0.75 -0.75 20 20" {...props}>
    <desc>{'Logout 1 Streamline Icon: https://streamlinehq.com'}</desc>
    <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}>
      <path d="M13.875 15.196v1.322a1.32 1.32 0 0 1-1.321 1.321h-9.25a1.32 1.32 0 0 1-1.322-1.321V1.982A1.32 1.32 0 0 1 3.304.661h9.25a1.32 1.32 0 0 1 1.321 1.321v1.322M7.268 9.25h9.25" />
      <path d="m13.875 6.607 2.643 2.643-2.643 2.643" />
    </g>
  </svg>
);
export default SvgLogout;
